import { saveAs } from 'file-saver'

export function saveMap3(url: string, name: string) {
  saveAs(url, `${name}.mp3`)
}
